import { checkAccessToPath } from 'frontend/common/access-helpers'
import { ResourceSectionType } from 'frontend/common/layout/enum/resource-section-type'
import { computed } from 'vue'

export function usePlacesSection(eou) {
  function hasAccessTo(path) {
    return checkAccessToPath(eou.value, path)
  }

  const section = computed(() => {
    const result = {
      name: 'Places',
      sectionType: ResourceSectionType.Places,
      items: [
        {
          title: 'Clusters',
          isDisabled: false,
          path: 'clusters',
          icon: 'mi-outlined mi-group-work',
        },
        {
          title: 'Locations',
          isDisabled: false,
          path: 'locations',
          icon: 'mi-outlined mi-location-on',
        },
        {
          title: 'Transportation points',
          isDisabled: false,
          path: 'transportation-points',
          icon: 'mi-outlined mi-workspaces',
        },
        {
          title: 'Staging Areas',
          isDisabled: false,
          path: 'staging-areas',
          icon: 'mi-outlined mi-workspaces',
        },
        {
          title: 'Depots',
          isDisabled: false,
          path: 'depots',
          icon: 'mi-outlined mi-corporate-fare',
        },
        {
          title: 'Origin X Destination Matrix',
          isDisabled: false,
          path: 'origin-x-destination-matrix',
          icon: 'fas fa-route',
        },
        {
          title: 'Map Zones',
          isDisabled: false,
          path: 'map-zones',
          icon: 'mi-outlined mi-layers',
        },
        {
          title: 'Gis Rules',
          isDisabled: false,
          // path: 'gis-rules',
          icon: 'mi-outlined mi-directions',
          action: event => {
            window.open(`/gis/${event.slug}`)
          },
        },
      ],
    }

    result.items = result.items.filter(el => hasAccessTo(el.path))
    if (result.items.length) {
      return result
    } else {
      return {}
    }
  })

  return section
}
